import React, { FC } from 'react';
import styles from './description-sections.module.scss';
import { SectionItem } from "../const";
import Button from '../../../ui-kit/button/button';
import { useTranslation } from 'react-i18next';
import {isRTL} from "../../../../utils/rtl";

interface IProps {
    items: SectionItem[];
}

const DescriptionSection: FC<IProps> = ({ items }) => {
    const { t } = useTranslation();
    return (
        <div className={styles.description} dir={isRTL() ? 'rtl' : 'ltr'}>
            {items.map((item, index) => (
                <div className={styles.descriptionItem} key={index}>
                    <img 
                        className={styles.descriptionImg} 
                        src={item.img} 
                        alt={t(item.alt)} 
                    />
                    <h3>{t(item.title)}</h3>
                    <p>{t(item.text)}</p>
                    {item.download && (
                        <a className={styles.link} href={item.download.url} download={item.download.fileName} style={{textDecorationLine:"none"}}>
                            <Button type="outline" className={styles.downloadButton}>
                                {t('about.content.exploreOpportunities.downloadButton')}
                            </Button>
                        </a>
                    )}
                </div>
            ))}
        </div>
    );
};

export default DescriptionSection;
